import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { GlobalVariable } from 'src/app/config/service.config';
import { Contact } from 'src/app/models/contact.model';
import { ContratoService } from 'src/app/services/contrato.service';
import { FaseService } from 'src/app/services/fase.service';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { EsignService } from 'src/app/services/esign.service';

declare var $: any;

@Component({
  selector: 'app-contrato',
  templateUrl: './contrato.component.html',
  styleUrls: ['./contrato.component.css']
})
export class ContratoComponent implements OnInit, OnDestroy {
  @Output() Fase: EventEmitter<string> = new EventEmitter();
  contratoForm: FormGroup;
  urls = GlobalVariable.API_CloudSigner;
  @Input() IdProceso: string = '';
  @Input() Alumno: Contact;
  @Input() faseActual: string;
  @Input() ultimafase: number;
  contratoSubcribe: Subscription;

  inforamar = false;
  trx = '';//Documento
  rut = ''; //RUT SIN - Guion
  rutapoderado = ''; //RUT SIN - Guion
  titulo = 'Validando Firma Digital';
  body = 'Por favor, espera mientras se genera la verificación de la firma digital.';
  InternalEstado = 0;
  EstadoAlerta = '0';
  progress = false;
  progress2 = false;
  iframe = false;
  url: string = ''
  urlSafe: SafeResourceUrl;
  openContrato = false;
  cargandoClave = true;
  progressButtonsSolicitarClave: boolean = false

  constructor(public sanitizer: DomSanitizer,
    private contratoservice: ContratoService,
    private route: ActivatedRoute,
    private esign: EsignService,
    private fb: FormBuilder,
    private faseService: ProcesoMatriculaService,
    public faseSubcribe: FaseService,
    private alerts: ToastrService) {
    this.contratoForm = fb.group({
      Firmantes: [false],
      UsuarioEnrolado: [false],
      GeneracionContrato: [false],
      BusquedaContrato: [false],
      EstadoContrato: [false]
    });
    this.route.params.subscribe(params => {
      if (params.id !== '' || params.id !== undefined) {
        this.IdProceso = `${params.id}`;
      }
    });
    this.contratoSubcribe = this.faseSubcribe.fase$.subscribe(
      value => {
        if (value == '5') {
          if (this.ultimafase > 5) {
            //TODO: Validar el estado del contrato
            this.contratoservice.getEstadoContrato(this.IdProceso).subscribe(
              (data: any) => {
                if (data.RetornoDesdeApi != null) {
                  if (data.RetornoDesdeApi[0].estado_firma === '3') {
                    this.Fase.emit('6');
                    this.faseSubcribe.fase$.emit('6');
                  } else {
                    this.titulo = 'Información';
                    this.body = 'Para avanzar de fase debe firmar el contrato';
                    this.progress = false;
                    this.goToBottomDiv();
                  }
                } else {
                  this.titulo = 'Información';
                  this.body = 'Para avanzar de fase debe firmar el contrato';
                  this.progress = false;
                  this.goToBottomDiv();
                }
              },
              (err) => {
                // This is intentional
              }
            );
          }
        }
      }
    );
  }
  ngOnDestroy(): void {
    this.contratoSubcribe.unsubscribe();
  }

  ngOnInit(): void {
    // This is intentional
  }

  proceso() {
    this.inforamar = true;
    switch (this.InternalEstado) {
      case 0:// Validando los firmantes
        this.ValidarFirmantes();
        break;
      case 1: //Validar enrolamiento del usuario
        this.ValidarEnrolamiento();
        break;
      case 2: // CRM ver si tiene contrato
        this.GeneraContrato();
        break;
      case 3:
        this.BuscarNombreDocumento();
        break;
      case 4:
        this.validarEstadoDocuemnto();
        break;

      default:
        break;
    }
  }

  validarEstadoDocuemnto() {
    this.titulo = 'Estado del contrato';
    this.body = 'Validando el estado del contrato';
    this.progress = true;
    this.contratoservice.getEstadoContrato(this.IdProceso).subscribe(
      (data: any) => {
        if (data.RetornoDesdeApi[0].estado_firma === '3') {
          this.titulo = 'Contrato';
          this.body = 'Estado del contrato ' + data.RetornoDesdeApi[0].glosa_estado_firma;
          this.OpenContrato();
        }
        if (data.RetornoDesdeApi[0].estado_firma === '5') {
          this.titulo = 'Contrato';
          this.body = 'Estado del contrato ' + data.RetornoDesdeApi[0].glosa_estado_firma;
          this.OpenContrato();
          this.progress = true;
        }
        this.contratoForm.controls.EstadoContrato.setValue(true);
        this.progress = false;
      },
      (err) => {
        this.progress = false;
      },
      () => {
        // This is intentional
      }
    );
  }

  ValidarEnrolamiento() {
    this.titulo = 'Validando firmas digitales';
    if (this.rut !== '') {
      this.contratoservice.getEstadoEnrolamiento(this.rut).subscribe(
        (data: any) => {
          const codigoEnrolamiento = data?.RetornoDesdeApi[0].Codigo;
          switch (codigoEnrolamiento) {
            case "1":
              // EL usuario se encuentra enrolado  OK
              this.contratoForm.controls.UsuarioEnrolado.setValue(true);
              if (this.rutapoderado !== '') {
                this.ValidarEnrolamientoApoderado();
              } else {
                this.InternalEstado = 2;
                this.proceso();
              }
              break;
            case "3":
              // EL usuario no se encuentra enrolado
              this.contratoForm.controls.UsuarioEnrolado.setValue(false);
              this.body = 'Aún no has generado tu certificado para firma digital, revisa tu correo e ingresa al enlace indicado.';
              this.titulo = 'Advertencia';
              this.progress = false;
              this.EstadoAlerta = '1';
              break;
            default:
              // fallo el proceso
              this.body = 'Aún no has generado tu certificado para firma digital, revisa tu correo e ingresa al enlace indicado.';
              this.titulo = 'Advertencia';
              this.progress = false;
              break;
          }
          //},
        }, (err) => {
          console.log("Error al validar enrolamiento alumno");
          // fallo la solicitud
          this.body = 'No se pudo validar la firma digital cloudSigner';
          this.EstadoAlerta = '2';
          this.progress = false;
        }
      );

    }
  }

  ValidarEnrolamientoApoderado() {
    if (this.rutapoderado !== '') {
      this.contratoservice.getEstadoEnrolamiento(this.rutapoderado).subscribe(
        (data: any) => {
          const codigoEnrolamiento = data?.RetornoDesdeApi[0].Codigo;
          switch (codigoEnrolamiento) {
            case "1":
              // EL usuario se encuentra enrolado  OK
              this.contratoForm.controls.UsuarioEnrolado.setValue(true);
              this.InternalEstado = 2;
              this.proceso();
              break;
            case "3":
              // EL usuario no se encuentra enrolado
              this.contratoForm.controls.UsuarioEnrolado.setValue(false);
              this.body = 'No se encuentra certificado para el apoderado en cloudSigner, porfavor valida tu correo electronico y confirma tu firma digital.';
              this.progress = false;
              this.EstadoAlerta = '1';
              break;
            default:
              // fallo el proceso
              this.body = 'No se encuentra certificado para el apoderado en cloudSigner, porfavor valida tu correo electronico y confirma tu firma digital.';
              this.progress = false;
              break;
          }
        },
        (err) => {
          console.log("Error al validar enrrolamiento apoderado");
          // fallo la solicitud
          this.body = 'No se pudo validar la firma digital cloudSigner';
          this.EstadoAlerta = '2';
          this.progress = false;
        }
      );

    }
  }

  OpenContrato() {
    this.progress = true;
    this.openContrato = true;
    this.titulo = this.trx == '' ? 'Sin contrato' : this.titulo;
    this.body = this.trx == '' ? 'Notificar a info@santotomas.cl, para la generacion del contrato' : this.body;
    //TODO: Validar con cloud sign como enviar el rut del apoderado o si no es neceario enviarlo y el iframe se encargará de solicitar la firma de ambos firmantes
    if (this.rutapoderado !== '') {
      this.url = `${this.urls}firmar_documento_secuencial.php?trx=${this.trx}&ruts=${this.rut},${this.rutapoderado}&huella=0`;
      console.log("URL Contrato: " + this.url);
    }
    else
      this.url = `${this.urls}firmar_documento_secuencial.php?trx=${this.trx}&ruts=${this.rut}&huella=0`;
    console.log("this.url  ", this.url)

    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    console.log("this.urlSafe ", this.urlSafe)
    this.iframe = true;
    this.progress = false;
  }

  SolicitarContrato() {
    this.proceso();
  }
  ValidarFirmantes() {
    this.titulo = 'Validando los Firmantes';
    this.body = 'Buscando firmantes de contrato...';
    this.progress = true;
    this.progress2 =true;
    this.contratoservice.getNombreDocumento(this.IdProceso).subscribe(
      (data: any) => {
        this.body = 'Procesando firmantes...';
        this.rut = data.Result?.AlumnoRut;
        this.rutapoderado = data.Result?.ApoderadoRut;
        this.trx = data.Result?.NombreDocumento;
        if (this.rut !== '') {
          this.contratoForm.controls.Firmantes.setValue(true);
          this.InternalEstado = 1;
          this.proceso();
        } else {
          this.progress = false;
          this.progress2 =false;
        }
      },
      (err) => {
        this.progress = false;
        this.progress2 =false;
        this.body = 'Se ha pedido la comunicacion del sitioweb.';
      }
    );
  }

  BuscarNombreDocumento() {
    this.progress = true;
    this.contratoservice.getNombreDocumento(this.IdProceso).subscribe(
      (data: any) => {
        this.trx = data.Result?.NombreDocumento;

        if (this.trx !== '') {
          this.contratoForm.controls.BusquedaContrato.setValue(true);
          this.InternalEstado = 4;
          this.proceso()
        } else {
          this.progress = false;
        }
      },
      (err) => {
        this.progress = false;
        this.titulo = 'Se ha pedido la comunicacion del sitioweb.'
      }
    );
  }

  GeneraContrato() {
    //Generando contrato
    this.titulo = 'Generando contrato';
    this.body = 'Esperar mientra se genera la documentacion para el contrato';
    this.progress = true;
    this.contratoservice.crearContra(this.rut, this.IdProceso).subscribe(
      (data: any) => {
        if (data.Codigo == 14) {
          this.titulo = 'Advertencia';
          this.body = "El contrato no se puede visualizar, contacte a Santo Tomás para la correcta generación de su contrato.";
          this.progress = false;
          this.EstadoAlerta = '1';
          return;
        }

        this.goToBottomDiv();
        this.contratoForm.controls.GeneracionContrato.setValue(true);
        this.InternalEstado = 3;
        this.proceso();
      },
      (err) => {
        this.progress = false;
        console.log(err);
      }
    )
  }

  goToBottomDiv() {
    const waitMillisecondsUntilFocus = 600;
    setTimeout(() => {
      try { $('html, body').animate({ scrollTop: $('#divBottom').offset().top }, 'slow'); } catch { }
    }, waitMillisecondsUntilFocus);
  }
  avanceFase() {

    if (this.faseActual !== '5') {
      return;
    }
    this.progress = true;
    this.inforamar = true;
    this.titulo = 'Evaluando estado de firma de contrato';
    this.body = 'Esperar...';
    this.contratoservice.getEstadoContrato(this.IdProceso).subscribe(
      (data: any) => {
        if (data.RetornoDesdeApi != null) {
          if (data.RetornoDesdeApi[0].estado_firma === '3') {
            if (this.faseActual === '5') {
              this.faseService.setFase(this.IdProceso, '6').subscribe(
                (dt) => {
                  this.progress = false;
                  this.Fase.emit('6');
                  this.faseSubcribe.fase$.emit('6');
                },
                (err) => {
                  this.titulo = 'Información';
                  this.body = 'Error al avanzar de fase. Contacte a un usuario de soporte de Santo Tomás';
                  this.progress = false;
                  this.goToBottomDiv();
                }
              );
            }
          } else {
            this.titulo = 'Información';
            this.body = 'Para avanzar de fase debe firmar el contrato';
            this.progress = false;
            this.goToBottomDiv();
          }
        } else {
          this.titulo = 'Información';
          this.body = 'Para avanzar de fase debe firmar el contrato';
          this.progress = false;
          this.goToBottomDiv();
        }

      },
      (err) => {
        this.titulo = 'Información';
        this.body = 'Error al avanzar de fase. Contacte a un usuario de soporte de Santo Tomás';
        this.progress = false;
        this.goToBottomDiv();
      }
    );
  }

  openModalInfoESign() {
    $('#infoCorreoESign').modal('show');
  }

  esignInit() {
    this.progress = true;
    this.progressButtonsSolicitarClave = true
    this.esign.CrearUsuario(this.Alumno.Rut, this.IdProceso).subscribe(
      (data) => {
        console.log('[ESING - Resultado de Crear usuario]', data)
        this.esign.CrearApoderado(this.IdProceso).subscribe(
          (res) => {
            this.cargandoClave = false;
            this.progress = false;
            this.progressButtonsSolicitarClave = false
            console.log('[ESING - Resultado de Crear apoderado]', res);
            this.openModalInfoESign();
          }
        )
      }
    )
  }
}
